'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _recompose = require('recompose');

var _offkey = require('offkey');

var _lodash = require('lodash');

var _offset = require('dom-helpers/query/offset');

var _offset2 = _interopRequireDefault(_offset);

var _FocusTrap = require('./FocusTrap');

var _FocusTrap2 = _interopRequireDefault(_FocusTrap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
function makeDefaultStyle(modal, backdrop) {
	var modalRect = (0, _offset2.default)(modal);
	var backdropRect = (0, _offset2.default)(backdrop);
	var margin = (backdropRect.height - modalRect.height) / 2;

	return {
		marginTop: margin + 'px'
	};
}

/**
 *
 */
var Modal = (_temp = _class = function (_Component) {
	_inherits(Modal, _Component);

	/**
  *
  */


	/**
  *
  */
	function Modal(props) {
		_classCallCheck(this, Modal);

		var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

		(0, _lodash.bindAll)(_this, 'handleKeyDown');
		return _this;
	}

	/**
  *
  */


	/**
  *
  */


	_createClass(Modal, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.updateStyle();
		}

		/**
   *
   */

	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.updateStyle();
		}

		/**
   *
   */

	}, {
		key: 'updateStyle',
		value: function updateStyle() {
			var _refs = this.refs;
			var modal = _refs.modal;
			var backdrop = _refs.backdrop;

			var style = this.props.makeStyle((0, _reactDom.findDOMNode)(modal), (0, _reactDom.findDOMNode)(backdrop));

			(0, _lodash.forEach)(style, function (value, property) {
				modal.style[property] = value;
			});
		}

		/**
   *
   */

	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (event.keyCode === _offkey.ESCAPE) {
				this.props.onClose();
			}
		}

		/**
   *
   */

	}, {
		key: 'render',
		value: function render() {
			var _props = this.props;
			var role = _props.role;
			var label = _props.label;
			var labelId = _props.labelId;
			var children = _props.children;


			var props = {
				role: role,
				tabIndex: 0,
				ref: 'backdrop',
				className: 'rea11y-Modal-backdrop',
				onKeyDown: this.handleKeyDown
			};

			if (labelId) {
				props['aria-labelledby'] = labelId;
			} else if (label) {
				props['aria-label'] = label;
			}

			return _react2.default.createElement(
				_FocusTrap2.default,
				null,
				_react2.default.createElement(
					'div',
					props,
					_react2.default.createElement(
						'div',
						{ className: 'rea11y-Modal', ref: 'modal' },
						children
					)
				)
			);
		}
	}]);

	return Modal;
}(_react.Component), _class.propTypes = {
	role: _react.PropTypes.oneOf(['dialog', 'alertdialog']),
	label: _react.PropTypes.string,
	labelId: _react.PropTypes.string,
	makeStyle: _react.PropTypes.func,
	onClose: _react.PropTypes.func,
	children: _react.PropTypes.any.isRequired
}, _class.defaultProps = {
	role: 'dialog',
	label: '',
	labelId: '',
	makeStyle: makeDefaultStyle,
	onClose: _lodash.noop
}, _temp);
exports.default = (0, _recompose.pure)(Modal);